module.exports = __webpack_public_path__ + "static/media/Памятка покупателю китайский язык.668c399d.pdf";